import type { ChatMessage } from '../types';
import { THINKING_MESSAGE_TYPE } from '../../drive-insights.constants';

export const PENDING_RESPONSE_ID_PREFIX = 'pending-response-';

export const createPromptMessage = (promptText: string, conversationId?: string): ChatMessage => ({
  type: 'prompt',
  id: `${Date.now()}-prompt`,
  content: promptText,
  conversationId: conversationId || '',
  createdAt: new Date().toISOString(),
});

export const createPendingResponseMessage = (conversationId?: string): ChatMessage => {
  const id = `${PENDING_RESPONSE_ID_PREFIX}${Date.now()}`;

  return {
    type: 'response',
    id,
    clientId: id,
    content: '',
    conversationId: conversationId || '',
    createdAt: new Date().toISOString(),
    isStreaming: true,
    isComplete: false,
    parsedContent: [],
    thinkingStartedAt: Date.now(),
  };
};

export const createThinkingMessage = (conversationId?: string): ChatMessage => ({
  type: THINKING_MESSAGE_TYPE,
  id: `${Date.now()}-${THINKING_MESSAGE_TYPE}`,
  content: THINKING_MESSAGE_TYPE,
  conversationId: conversationId || '',
  createdAt: new Date().toISOString(),
});
